<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 fxHide.sm fxHide.md fxHide.lg fxHide.xl>
                {{ t("application.tab.background") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/demographics-icon.svg"
                        alt="demographics-icon"
                    />
                    <h2>{{ t("application.background.header") }}</h2>
                    <app-background-form
                        [fields]="fields$ | async"
                        [value]="formValue$ | async"
                        (submitted)="onSubmitted($event)"
                    ></app-background-form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            ></div>
        </div>
    </div>
</ng-container>
